import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { InputText } from "primereact/inputtext";
import {
  addDoc,
  and,
  collection,
  doc,
  getDocs,
  or,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import ErrorMessages from "helper/errorMessages";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import { dbFirestore } from "helper/config/firebase";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

function AddPTEStudents() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [pteStudentsHeading, setPteStudentsHeading] = useState(
    CommonHeadings.pteStudentAddHeading
  );
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [pteStudentsID, setPteStudentsID] = useState();
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [pteStudents, setPteStudents] = useState({
    student_firebase_id: null,
    student_type: null,
    pte_id: "",
    user_name: "",
    pte_password: "",
    phone_number: "",
    email: "",
    pte_student_name: "",
  });

  const [errors, setErrors] = useState({
    student_firebase_id: "",
    student_type: "",
    pte_id: "",
    user_name: "",
    pte_password: "",
    phone_number: "",
    email: "",
    pte_student_name: "",
  });

  // MARK: Use Effect Method
  useEffect(() => {
    //  edit functionality
    if (location.state) {
      setEditPteStudentsUI();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Use Layout Method
  useLayoutEffect(() => {
    document.title = location.state
      ? CommonHeadings.pteStudentEditHeading
      : CommonHeadings.pteStudentAddHeading;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const validateForm = (data) => {
    const errors = {};

    if (!data.student_type) {
      errors.student_type = ErrorMessages.studentInfo;
    }
    if (!data.pte_id) {
      errors.pte_id = ErrorMessages.pteId;
    }
    if (!data.user_name) {
      errors.user_name = ErrorMessages.name;
    }
    if (!data.pte_password) {
      errors.pte_password = ErrorMessages.password;
    }
    if (!data.pte_student_name) {
      errors.pte_student_name = ErrorMessages.pteStudentName;
    }
    if (!data.email.trim()) {
      errors.email = ErrorMessages.email;
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = ErrorMessages.emailPattern;
    }
    if (!data.phone_number) {
      errors.phone_number = ErrorMessages.phone;
    } else if (!/^\d*$/.test(data.phone_number)) {
      errors.phone_number = ErrorMessages.phoneNumber;
    }
    if (data.student_type === "existing_student") {
      if (!data.student_firebase_id) {
        errors.student_firebase_id = ErrorMessages.studentId;
      }
    }

    return errors;
  };

  //   when we enter any value that's set in the setDemoStudents() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    const { name, value } = e.target;

    setPteStudents({
      ...pteStudents,
      [name]: value,
    });
  };

  const studentsAdmissionSelect = (e) => {
    const name = "student_firebase_id";

    setPteStudents({
      ...pteStudents,
      [name]: e,
    });

    if (e === null) {
      return;
    }

    setPteStudents((prevState) => ({
      ...prevState,
      phone_number: e.contact_no,
      email: e.email,
      pte_student_name: e.name,
    }));
  };

  const studentsTypeSelect = (e) => {
    const name = "student_type";

    setPteStudents({
      ...pteStudents,
      [name]: e,
    });

    if (e.type === "new_student") {
      setPteStudents((prevState) => ({
        ...prevState,
        pte_student_name: "",
        email: "",
        phone_number: "",
      }));
    }
  };

  // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(pteStudents);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      location.state ? updatePteStudentsApi() : writePteStudentsApi();
    }
  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(pteStudents);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writePteStudentsApi(true);
    }
  };

  // MARK: edit data function
  async function setEditPteStudentsUI() {
    const studentTypeObject = await fetchStudentTypeApi();
    var regularStudentObject;
    if (studentTypeObject.type === "existing_student") {
      regularStudentObject = await fetchRegularStudentApi();
    } else {
      regularStudentObject = null;
    }

    setPteStudents((prevState) => ({
      ...prevState,
      student_firebase_id: regularStudentObject,
      student_type: studentTypeObject,
      pte_id: location.state.pte_id,
      user_name: location.state.user_name,
      pte_password: location.state.pte_password,
      phone_number: location.state.phone_number,
      email: location.state.email,
      pte_student_name: location.state.pte_student_name,
    }));
    setPteStudentsHeading(CommonHeadings.pteStudentEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setPteStudentsID(location.state.id);
  }

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();
    const object = {
      ...pteStudents,
      created_at: createdAt,
      updated_at: null,
    };

    object.user_name = pteStudents.user_name.toLowerCase();
    object.email = pteStudents.email.toLowerCase();
    object.pte_student_name = pteStudents.pte_student_name.toLowerCase();

    return object;
  }

  // MARK: reset values function
  function ResetValues() {
    setPteStudents({
      student_firebase_id: "",
      student_type: "",
      pte_id: "",
      user_name: "",
      pte_password: "",
      phone_number: "",
      email: "",
      pte_student_name: "",
    });
  }

  // MARK:API
  // student type API
  async function fetchStudentTypeApi() {
    let q = query(collection(dbFirestore, TableName.studentsType));

    const querySnapshot = await getDocs(q);

    const studentTypeArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    var typeObject = studentTypeArray.find(function (studentType) {
      return studentType.type === location.state.student_type;
    });
    return typeObject;
  }

  // regular student API
  async function fetchRegularStudentApi() {
    let q = query(collection(dbFirestore, TableName.students));

    const querySnapshot = await getDocs(q);

    const regularStudentArray = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    const studentObject = regularStudentArray.find(function (student) {
      return (student.firebase_id = location.state.student_firebase_id);
    });
    return studentObject;
  }

  // write API
  async function writePteStudentsApi(edit) {
    const writePayload = payload();
    writePayload.student_type = pteStudents.student_type.type;
    if (pteStudents.student_firebase_id) {
      writePayload.student_firebase_id =
        pteStudents.student_firebase_id.firebase_id;
    }

    try {
      await addDoc(collection(dbFirestore, TableName.pteStudents), {
        ...writePayload,
      });

      if (edit) {
        toast.success(ToastMessages.pteStudentsAdd);
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addPteStudents);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.pteStudentsAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.pteStudentsList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // update API
  async function updatePteStudentsApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();
    updatedPayload.student_type = pteStudents.student_type.type;

    if (pteStudents.student_firebase_id) {
      updatedPayload.student_firebase_id =
        pteStudents.student_firebase_id.firebase_id;
    }

    try {
      await updateDoc(doc(dbFirestore, TableName.pteStudents, pteStudentsID), {
        ...updatedPayload,
      });

      toast.success(ToastMessages.pteStudentsUpdated);
      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.pteStudentsList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: students list fetch from the firebase
  const regularStudentsList = async (searchText) => {
    const searchName = searchText.toLowerCase()
    let q = query(
      collection(dbFirestore, TableName.students), and(
              where('status', '==', 'active'),   
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        ),
      )
    ));
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      firebase_id: docs.id,
    }));

    return s;
  };

  // students name which show in the dropdown
  function studentsAdmissionNumber(e) {
    return e["name"] + " - " + e["admission_no"];
  }

  // MARK: students list fetch from the firebase
  const studentsTypeList = async (searchText) => {
    const searchName = searchText.toLowerCase()

    let q = query(
      collection(dbFirestore, TableName.studentsType),
      or(
        // query as-is:
        and(
          where("type", ">=", searchName),
          where("type", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "type",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "type",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    );
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
    }));

    return s;
  };

  // students name which show in the dropdown
  function studentsType(e) {
    return e["type"];
  }

  // MARK: UI
  //  data pass dynamically in row and columns
  const rowPteStudentsData = [
    {
      label: "PTE ID",
      classNameLabel: "input__valid",
      name: "pte_id",
      value: pteStudents.pte_id,
      change: inputChange,
      type: "text",
      placeholder: "Enter PTE ID",
      error: errors.pte_id,
    },
    {
      label: "PTE User Name",
      classNameLabel: "input__valid",
      name: "user_name",
      value: pteStudents.user_name,
      change: inputChange,
      id: "user_name",
      type: "text",
      placeholder: "Enter pte user name",
      error: errors.user_name,
    },
    {
      label: "PTE Voucher Name",
      classNameLabel: "input__valid",
      name: "pte_student_name",
      value: pteStudents.pte_student_name,
      change: inputChange,
      id: "pte_student_name",
      type: "text",
      placeholder: "Enter pte student name",
      error: errors.pte_student_name,
    },
    {
      label: "PTE Password",
      classNameLabel: "input__valid",
      name: "pte_password",
      value: pteStudents.pte_password,
      change: inputChange,
      id: "pte_password",
      type: "text",
      placeholder: "Enter pte password",
      error: errors.pte_password,
    },
    {
      label: "Email",
      classNameLabel: "input__valid",
      name: "email",
      value: pteStudents.email,
      change: inputChange,
      id: "email",
      type: "email",
      placeholder: "Enter your email",
      error: errors.email,
    },
    {
      label: "Contact Number",
      classNameLabel: "input__valid",
      name: "phone_number",
      value: pteStudents.phone_number,
      change: inputChange,
      type: "tel",
      placeholder: "Enter your contact number",
      length: 10,
      error: errors.phone_number,
    },
  ];

  return (
    <div className="modules__main__div">
      <div className="col-12 ">
        <div className="card modules__card">
          <HeadingComponent classname="mb-1 mt-3" headingName={pteStudentsHeading} />
          {/* p-fluid is the primereact class */}
          <div className="p-fluid">
            <div className="row modules__row mt-4">
              <div className="col-12 col-md-6">
                <label htmlFor="student_type" className="input__valid">Student Type</label>
                <AsyncSelect
                  classNamePrefix="batch__dropdown"
                  isClearable
                  cacheOptions
                  loadOptions={studentsTypeList}
                  value={pteStudents.student_type}
                  defaultOptions
                  getOptionLabel={(e) => studentsType(e)}
                  onChange={studentsTypeSelect}
                />
                {isSubmitted && (
                  <small id="student_type" className="p-error">
                    {errors.student_type}{" "}
                  </small>
                )}
              </div>

              {pteStudents.student_type?.type === "existing_student" && (
                <div className="col-12 col-md-6">
                  <label htmlFor="student_firebase_id" className="input__valid">Select Student</label>
                  <AsyncSelect
                    isClearable
                    cacheOptions
                    loadOptions={regularStudentsList}
                    value={pteStudents.student_firebase_id}
                    defaultOptions
                    getOptionLabel={(e) => studentsAdmissionNumber(e)}
                    getOptionValue={(e) => e["id"]}
                    onChange={studentsAdmissionSelect}
                  />
                  {isSubmitted && (
                    <small id="student_firebase_id" className="p-error">
                      {errors.student_firebase_id}{" "}
                    </small>
                  )}
                </div>
              )}
            </div>

            <div className="row modules__row">
              <HeadingComponent
                classname="mt-4 mb-1"
                headingName="Personal Information"
              />
              {rowPteStudentsData.map((col) => (
                <div className="col-12 col-md-6">
                  <label htmlFor={col.name} className={col.classNameLabel}>{col.label}</label>
                  {col.type && (
                    <InputText
                      name={col.name}
                      value={col.value}
                      onChange={col.change}
                      id={col.name}
                      type={col.type}
                      placeholder={col.placeholder}
                      maxLength={col.length}
                    />
                  )}
                  {isSubmitted && (
                    <small id={col.name} className="p-error">
                      {col.error}{" "}
                    </small>
                  )}
                </div>
              ))}
            </div>
          </div>
          <BottomButtons
            label={buttonLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddPTEStudents;
